import { connect } from 'react-redux';
import { pipe, propOr } from 'ramda';
import { mapProps, compose, withHandlers } from 'recompose';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getExtrasData } from '@olxbr/mojo-jojo/selectors/extras';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';
import { getCurrentContent } from '@olxbr/mojo-jojo/selectors/content';

import { buildQueryString, getSource } from '../core/libs/browser/browser';
import { sendBuyClick } from '../core/services/tracking';
import CheckoutButton from './CheckoutButton';

const getLabel = pipe(
  getCurrentContent,
  propOr('Comprar', 'checkoutButton'),
);

const mapStateToProps = state => ({
  extrasData: getExtrasData(state),
  posData: getPOSData(state),
  adData: getAdData(state),
  label: getLabel(state),
});

const withPurchaseUrl = ({
  posData, adData, extrasData, product, ...props
}) => {
  const { REACT_APP_OCTOPOS_HOST } = process.env;
  const { type: productCode } = product;
  const {
    name: posName,
    parentName,
    coupon,
    funnelId,
  } = posData;
  const { adId } = adData;

  const referralParam = document.location.search.match(/referral=([a-zA-Z_-]*)/);
  const referral = referralParam ? referralParam[1] : '';
  const utms = (document.location.search.match(/(utm_[\w]+=[\w_-]*)/g) || []).join('&');

  const { tag_id: tagId, product_name: productName } = propOr({}, 'rtb', extrasData);

  const platform = getSource();
  const queryStringToActivate = buildQueryString({
    adId, productCode, pointOfSale: parentName, platform, referral, coupon, rtb_tag_id: tagId, rtb_product_name: productName, funnelId,
  }, utms);
  const queryStringToBuy = buildQueryString({
    adId, productCode, pointOfSale: posName, platform, referral, coupon, rtb_tag_id: tagId, rtb_product_name: productName, funnelId,
  }, utms);

  const paymentUrl = () => (product.totalPrice === 0
    ? `${REACT_APP_OCTOPOS_HOST}/api/v1/activate${queryStringToActivate}`
    : `${REACT_APP_OCTOPOS_HOST}/api/v1/buy${queryStringToBuy}`);

  return {
    ...props,
    product,
    url: paymentUrl(),
  };
};

const configureHandlers = withHandlers({
  onClick: ({ product, posData, adData }) => () => {
    const { type: productCode } = product;
    const { parentName, referral, funnelId } = posData;
    const {
      legacyAdId,
      listId,
      categoryId,
      region,
      zipcode,
    } = adData;

    sendBuyClick({
      adId: legacyAdId,
      listId,
      product: productCode,
      pointOfSale: parentName,
      referral,
      funnelId,
      categoryId,
      region,
      zipcode,
    });
  },
});

export default compose(
  connect(mapStateToProps),
  configureHandlers,
  mapProps(withPurchaseUrl),
)(CheckoutButton);
